import React from "react";

/**
 * Sub imaginea întrebării: de câte ori a răspuns elevul corect / greșit la ea
 * (bilete + teme, pentru totdeauna). Lățimile urmează proporția, între 10% și
 * 90% ca cifrele să încapă; fără răspunsuri — jumătate / jumătate. Lățimea se
 * schimbă animat (același element rămâne între întrebări).
 */
export function questionStatSplit(correct, wrong) {
   const ok = Math.max(0, Number(correct) || 0);
   const bad = Math.max(0, Number(wrong) || 0);
   const total = ok + bad;
   const pct = total > 0 ? Math.round((100 * ok) / total) : 50;
   return Math.min(90, Math.max(10, pct));
}

export default function QuestionStatBar({ correct = 0, wrong = 0, label }) {
   const okWidth = questionStatSplit(correct, wrong);
   return (
      <div className="question-stat" role="img" aria-label={label}>
         <div
            className="question-stat__part question-stat__part--ok"
            style={{ width: `${okWidth}%` }}
         >
            {Math.max(0, Number(correct) || 0)}
         </div>
         <div
            className="question-stat__part question-stat__part--bad"
            style={{ width: `${100 - okWidth}%` }}
         >
            {Math.max(0, Number(wrong) || 0)}
         </div>
      </div>
   );
}
